// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface AssessmentState {
//   assessmentId: string | null;

// }

// const initialState: AssessmentState = {
//   assessmentId: null,
// };

// const assessmentSlice = createSlice({
//   name: 'assessment',
//   initialState,
//   reducers: {
//     setAssessmentId(state, action: PayloadAction<string>) {
//       state.assessmentId = action.payload;
//     },
//     clearAssessmentId(state) {
//       state.assessmentId = null;
//     },
//   },
// });

// export const { setAssessmentId, clearAssessmentId } = assessmentSlice.actions;

// export default assessmentSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AssessmentState {
  assessmentId: string | null;
  status: string;
  currentCounter: number;
  timeReduxSpend: number;
  totalQuestion: number;
  isIndependent: boolean;
  duration: number;
}

const initialState: AssessmentState = {
  assessmentId: null,
  status: "NOTSTARTED",
  currentCounter: 0,
  timeReduxSpend: 0,
  totalQuestion: 0,
  isIndependent: false,
  duration: 0,
};

const assessmentSlice = createSlice({
  name: "assessment",
  initialState,
  reducers: {
    setAssessmentId(state, action: PayloadAction<string>) {
      state.assessmentId = action.payload;
    },
    setStatus(state, action: PayloadAction<string>) {
      state.status = action.payload;
    },
    setCurrentCounter(state, action: PayloadAction<number>) {
      state.currentCounter = action.payload;
    },
    setTimeSpend(state, action: PayloadAction<number>) {
      state.timeReduxSpend = action.payload;
    },
    setTotalQuestion(state, action: PayloadAction<number>) {
      state.totalQuestion = action.payload;
    },
    setIsIndependent(state, action: PayloadAction<boolean>) {
      state.isIndependent = action.payload;
    },
    setDuration(state, action: PayloadAction<number>) {
      state.duration = action.payload;
    },
    clearAssessment(state) {
      state.status = "";
      state.currentCounter = 0;
      // state.timeReduxSpend = 0;
      state.totalQuestion = 0;
      state.isIndependent = false;
      state.duration = 0;
    },
    clearAssessmentId(state) {
      state.assessmentId = null;
    },
  },
});

export const {
  setAssessmentId,
  setStatus,
  setCurrentCounter,
  setTimeSpend,
  setTotalQuestion,
  setIsIndependent,
  setDuration,
  clearAssessment,
  clearAssessmentId,
} = assessmentSlice.actions;

export default assessmentSlice.reducer;
